import React, { useState, useEffect } from "react";
import { fromJS } from "immutable";
import { connect } from "react-redux";
import { TabPanel } from "react-web-tabs";
import { Form, Field, reduxForm, getFormValues } from "redux-form";
import { ToastContainer, toast } from "react-toastify";
import { Input, DropDown } from "../common/input";
import { getState } from "../../action/user_action";
import { axiosInstnace as Axios, getUserData } from "../../util/util";
import { endPoints } from "../../config";
import { Multiselect } from "multiselect-react-dropdown";
import VerifyMobile from "../salesUser/campaign/verifymobilejs";

const SignUp = (props) => {
  //Initial state
  const { handleSubmit, onSubmit } = props;
  const [arrow, handleArrow] = useState("select_state");
  const [arrow1, handleArrow1] = useState("select_state");
  const [arrow2, handleArrow2] = useState("select_state");
  const [inputArray, handleInputArray] = useState([]);
  const [stateList, handleCityState] = useState([]);
  const [districtList, handleDistrict] = useState([]);
  const [cityList, handleCity] = useState([]);
  const [count, handleCount] = useState(1);
  //  const [industryList] = useState(fromJS([{name: "Advertising Agency", value:1}, {name: "Apparel & Garments", value:2}, {name: "E Commerce", value:3},{name:"Education", value:4}, {name:"Electronic and Electricals", value:5},{name:"FMCG", value:6},{name:"Handicrafts & Decoratives", value:7},{ name:"Herbal & Ayusrvedic products" , value:8}]))
  const [industryList, handleIndustryList] = useState([]);
  const [verifyCode, handleverifyCode] = useState("false");
  const [verifypopup, handleverifypopup] = useState(false);
  const [verifyoption, handleverifyoption] = useState(false);
  //Fetching city state
  useEffect(() => {
    props.getState();
  }, []);

  //Fetching state list
  useEffect(() => {
    
    if (props.stateList && props.stateList.size > 0 && count === 1) {
      console.log(props.stateList.toJS);
      let stateList = props.stateList.toJS().map((s) => ({
        name: s,
        value: s,
      }));
      handleCityState(fromJS(stateList));
      console.log(stateList);
      handleCount(count + 1);
      getIndustryList();
    }
  });

  const showverify = (e) => {
    if (e.target.value.length === 10) {
      handleverifyoption(true);
    } else {
      handleverifyoption(false);
    }
  };

  const checkmobileVerification = (values) => {
    
    if (Object.keys(values).length === 0 && !toast.isActive("1")) {
      toast.error("Please provide input for SIGN UP", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "1",
      });
      return;
    }
    if (!values.email) {
      toast.error("Please provide the email", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        toastId: "1",
        autoClose: false,
      });
      return;
    }
    let verified = document.querySelector("input[name='code']").value;
    if (!verified || verified === "false") {
      toast.error("Please verify the mobile number", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        toastId: "1",
        autoClose: false,
      });
      return;
    }
    onSubmit(values);
  };

  const getIndustryList = async () => {
    const response = await Axios.get(`${endPoints.getIndustryList}`);
    let industryList = response.data.data.data;
    handleIndustryList(fromJS(industryList));
  };

  const hadleStateCity = async (state) => {
    const response = await Axios.get(`${endPoints.getCities}?state=${state}`);
    console.log(response.data.data.data);
    let cityList = response.data.data.data;
    handleCityItems(cityList);
  };

  const handleCityItems = (cityList) => {
    let cityListItems = cityList.map((d) => ({
      name: d.city,
      value: d.city,
    }));
    console.log(cityListItems);
    handleCity(fromJS(cityListItems));
  };

  const handleArrowClick = () => {
    handleArrow("select_state dropdown_open");
  };
  const handleArrowClick1 = () => {
    handleArrow1("select_state dropdown_open");
  };
  const handleArrowClick2 = () => {
    handleArrow2("select_state dropdown_open");
  };

  const hideshowverifymobilepopup = (e) => {
    if (!props.formStates.mobile.match(/^[6789]\d{9}$/)) {
      toast.error("Please enter a valid Phone Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    handleverifypopup(!verifypopup);
  };
  const handlemobileverify = (e) => {
    handleverifyCode("true");
    document.querySelector("input[name='code']").value = "true";
    handleverifypopup(!verifypopup);
  };
  const handleArrowChange = (e) => {
    console.log(e.target.value);
    handleArrow("select_state");
    handleInputArray(inputArray);
    hadleStateCity(e.target.value);
  };

  const handleArrowChange1 = (e) => {
    handleArrow1("select_state");
    handleInputArray(inputArray);
  };

  const handleArrowChange2 = (e) => {
    console.log(inputArray);
    console.log(e.target.value);
    handleArrow2("select_state");
    handleInputArray(inputArray);
  };

  //Return signup page
  return (
    <div>
      <TabPanel tabId="signup" className="signup_scroll">
        <Form
          className="login_form_inner"
          onSubmit={handleSubmit(checkmobileVerification)}
        >
          <input style={{ display: "none" }} />
          <input type="password" style={{ display: "none" }} />
          <div className="input_wrapper">
            <img src="../../../assets/images/ic_name.png" />
            <Field type="text" name="name" label="Name" component={Input} />
          </div>
          <div className="input_wrapper">
            <img src="../../../assets/images/ic_company.png" />
            <Field
              type="text"
              name="company"
              label="Company Name"
              component={Input}
            />
          </div>
          <div className="input_wrapper" onClick={handleArrowClick}>
            <img src="../../../assets/images/ic_location.png" />
            <Field
              type="text"
              name="state"
              label="State"
              component={DropDown}
              options={stateList}
              arrow={arrow}
              inputArray={inputArray}
              onChange={handleArrowChange}
            />
          </div>
          <div className="input_wrapper" onClick={handleArrowClick2}>
            <img src="../../../assets/images/ic_location.png" />
            <Field
              type="text"
              name="city"
              label="City"
              component={DropDown}
              options={cityList}
              arrow={arrow}
              inputArray={inputArray}
              onChange={handleArrowChange2}
            />
          </div>

          <div className="input_wrapper" onClick={handleArrowClick1}>
            <img src="../../../assets/images/ic_location.png" />
            <Field
              type="text"
              name="industry"
              label="Industry"
              component={DropDown}
              options={industryList}
              onChange={handleArrowChange1}
              arrow={arrow1}
            />
          </div>
          <div className="input_wrapper  email_wrapper">
            <img src="../../../assets/images/ic_email.png" />
            <Field
              type="text"
              name="email"
              label="Email ID"
              autoComplete="new-password"
              component={Input}
            />
          </div>
          <div className="input_wrapper">
            <img src="../../../assets/images/ic_mobile.png" />
            <div>
              {verifyoption && verifyCode === "false" && (
                <a
                  style={{
                    float: "right",
                    color: "blue",
                    fontSize: "19px",
                  }}
                  onClick={hideshowverifymobilepopup}
                >
                  Verify
                </a>
              )}
              {verifyCode === "true" && (
                <a
                  style={{
                    float: "right",
                    color: "blue",
                    fontSize: "13px",
                  }}
                >
                  Verified
                </a>
              )}
              <Field
                type="number"
                name="mobile"
                component={Input}
                label="Mobile Number"
                onChange={showverify}
                component={Input}
              />
            </div>
          </div>
          <div className="input_wrapper">
            <div>
              <Field
                type="text"
                name="code"
                hidden={true}
                // value={verifyCode}
                component={Input}
              />
            </div>
          </div>
          <div className="input_wrapper">
            <img src="../../../assets/images/ic_password.png" />
            <Field
              autoComplete="new-password"
              type="password"
              name="password"
              label="Password"
              component={Input}
            />
          </div>
          <div className="input_wrapper">
            <img src="../../../assets/images/ic_password.png" />
            <Field
              autoComplete="new-password"
              type="password"
              name="confirmPassword"
              label="Confirm Password"
              component={Input}
            />
          </div>
          <div>
            <button type="submit" style={{ display: "none" }}>
              {" "}
            </button>
          </div>
        </Form>
      </TabPanel>
      {verifypopup && (
        <VerifyMobile
          isShowing={true}
          verify={handlemobileverify}
          mobile={props.formStates.mobile}
          hide={hideshowverifymobilepopup}
        />
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => (
  
  {
    stateList: state.user.get("stateList"),
    formStates: getFormValues("signup")(state), // here 'form' is the name you have given your redux form
  }
);

export default connect(mapStateToProps, {
  getState,
})(
  reduxForm({
    form: "signup",
  })(SignUp)
);



// WEBPACK FOOTER //
// ./web/components/signUp/signUp.js